// extracted by mini-css-extract-plugin
export var integrationButton = "_bg-0";